import { stringify } from 'query-string';
import { nodeAPIUrl } from '../constants';
import { fetchJson } from '../dataProvider';

const ENDPOINT = 'notifications/fcm-token';

const mapToken = (item: any) => ({
  ...item,
  id: item._id,
  userId: item.user,
});

export const notificationsApi = {
  getList: async (_resource: string, params: any) => {
    try {
      const { page, perPage } = params.pagination;
      const { field, order } = params.sort;
      const query: any = {
        page,
        limit: perPage,
      };
      if (field && order) {
        query.sortBy = `${field}:${order.toLowerCase()}`;
      }
      // Add filters if needed
      if (params.filter) {
        Object.assign(query, params.filter);
      }
      const url = `${nodeAPIUrl}/${ENDPOINT}?${stringify(query)}`;
      const { json } = await fetchJson(url);
      const data = Array.isArray(json.data) ? json.data.map(mapToken) : [];
      // Backend should ideally return total count, but fallback to data.length
      const total = json.total || data.length;
      return {
        data,
        total,
      };
    } catch (e) {
      return {
        data: [],
        total: 0,
      };
    }
  },

  getOne: async (_resource: string, params: { id: any }) => {
    const url = `${nodeAPIUrl}/${ENDPOINT}/${params.id}`;
    const { json } = await fetchJson(url);
    return { data: mapToken(json.data) };
  },

  create: async (_resource: string, params: { data: any }) => {
    const url = `${nodeAPIUrl}/${ENDPOINT}`;
    const { json } = await fetchJson(url, {
      method: 'POST',
      body: JSON.stringify(params.data),
      headers: new Headers({ 'Content-Type': 'application/json' }),
    });
    return { data: mapToken(json.data) };
  },

  update: async (_resource: string, params: { id: any; data: any }) => {
    const url = `${nodeAPIUrl}/${ENDPOINT}/${params.id}`;
    const { json } = await fetchJson(url, {
      method: 'PUT',
      body: JSON.stringify(params.data),
      headers: new Headers({ 'Content-Type': 'application/json' }),
    });
    return { data: mapToken(json.data) };
  },

  delete: async (_resource: string, params: { id: any }) => {
    const url = `${nodeAPIUrl}/${ENDPOINT}/${params.id}`;
    const { json } = await fetchJson(url, {
      method: 'DELETE',
    });
    return { data: mapToken(json.data) };
  },
}; 